/* eslint-disable react/prop-types */

import React, { useEffect, useRef, useState } from 'react';
import { find } from 'lodash';
import { Row, Col } from 'reactstrap';
import { Field } from '@cordata/buffet';

import { authorizedInstance as axios } from '~/utils';
import { useFormikContext } from 'formik';

const LocationForm = ({
  index,
  includeName,
  includePhones,
  includeCounty,
}) => {
  const {
    values,
    status,
    setFieldValue,
    setStatus,
  } = useFormikContext();
  const [states, setStates] = useState([]);
  const initialLoad = useRef(true);

  useEffect(() => {
    setStatus({
      [`address-${index}`]: {
        state: {
          working: true,
        },
      },
    });

    axios
      .get('/api/reference-admin/reference-country-division?country-abbrev-iso=US')
      .then(r => r.data.data)
      .then((r) => {
        setStates(r);

        if (values.addresses[index].state && values.addresses[index].state.length === 2) {
          setFieldValue(`addresses.${index}.state`, find(r, s => (values.addresses[index].state === s.attributes.divisionAbbrevIso)));
        }

        setStatus({
          [`address-${index}`]: {
            state: {
              working: false,
            },
          },
        });
      });
  }, []);

  const onPostCodeChange = (postCode) => {
    if (postCode && postCode.replace(/\D/g, '').length >= 5) {
      setStatus({
        [`address-${index}`]: {
          county: {
            working: true,
          },
          city: {
            working: true,
          },
          state: {
            working: true,
          },
        },
      });

      axios
        .get(`/api/reference-admin/reference-geo-data?zip_code=${postCode}`)
        .then(r => r.data.data)
        .then(r => r[0])
        .then((r) => {
          setFieldValue(`addresses.${index}.county`, r ? r.attributes.county : undefined);
          setFieldValue(`addresses.${index}.city`, r ? r.attributes.city : undefined);
          setFieldValue(`addresses.${index}.state`, find(states, s => r && s.attributes.divisionAbbrevIso === r.attributes.state));

          setStatus({
            [`address-${index}`]: {
              county: {
                working: false,
              },
              city: {
                working: false,
              },
              state: {
                working: false,
              },
            },
          });
        });
    }
  };

  useEffect(() => {
    if (values.addresses[index].postCode && states.length) {
      if (initialLoad.current) {
        initialLoad.current = false;
        return;
      }
      onPostCodeChange(values.addresses[index].postCode);
    }
  }, [values.addresses[index].postCode, states]);

  return (
    <>
      {includeName && (
      <Field
        name={`addresses.${index}.name`}
        label="Name"
        placeholder="Enter name"

      />)}

      <Row form>
        <Col sm>
          <Field
            name={`addresses.${index}.address1`}
            label="Address 1"
            placeholder="Enter address 1"

          />
        </Col>

        <Col sm>
          <Field
            name={`addresses.${index}.address2`}
            label="Address 2"
            placeholder="Enter your address 2"
          />
        </Col>
      </Row>

      <Row form>
        <Col sm>
          <Field
            name={`addresses.${index}.postCode`}
            label="Post Code"
            placeholder="Enter Post Code"
          />
        </Col>

        <Col sm>
          <Field
            name={`addresses.${index}.city`}
            label="City"
            placeholder="Enter City"
            loading={status && status[`address-${index}`] && status[`address-${index}`].city ? status[`address-${index}`].city.working : undefined}
          />
        </Col>

        <Col sm>
          <Field
            name={`addresses.${index}.state`}
            label="State"
            placeholder="Enter State"
            options={states}
            type="select"
            loading={status && status[`address-${index}`] && status[`address-${index}`].state ? status[`address-${index}`].state.working : undefined}
            getOptionValue={o => o.attributes.divisionAbbrevIso}
            getOptionLabel={o => o.attributes.divisionLabel}
          />
        </Col>

        {includeCounty && (
        <Col sm>
          <Field
            name={`addresses.${index}.county`}
            label="County"
            placeholder="Enter County"
            loading={status && status[`address-${index}`] && status[`address-${index}`].county ? status[`address-${index}`].county.working : undefined}
          />
        </Col>)}
      </Row>

      {includePhones && (
      <Row form>
        <Col sm>
          <Field
            name={`addresses.${index}.officeNumber`}
            label="Office Phone"
            type="tel"
            placeholder="Enter office number"

          />
        </Col>

        <Col sm>
          <Field
            name={`addresses.${index}.faxNumber`}
            label="Fax Phone"
            type="tel"
            placeholder="Enter fax number"
          />
        </Col>
      </Row>)}
    </>
  );
};

export default LocationForm;
